import { client } from '@/client';
import { MessageResponseModel } from '@/client/models';
import { GenericForbiddenApiError } from '@/hooks/query/types';
import { useMutation, useQueryClient } from 'react-query';

export const useAcceptDpaAmendment = (
  accountId: string,
): {
  acceptDpa: () => Promise<MessageResponseModel>;
  isLoading: boolean;
} => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation<
    MessageResponseModel,
    GenericForbiddenApiError,
    void
  >('accept-dpa-amendment', () => client.accountOsint.acceptDpa(accountId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['account', accountId]);
    },
  });

  return { acceptDpa: mutateAsync, isLoading: rest.isLoading };
};

export const useWithdrawDpaAmendment = (
  accountId: string,
): {
  withdrawDpa: () => Promise<MessageResponseModel>;
  isLoading: boolean;
} => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation<
    MessageResponseModel,
    GenericForbiddenApiError,
    void
  >(
    'withdraw-dpa-amendment',
    () => client.accountOsint.withdrawDpa(accountId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['account', accountId]);
      },
    },
  );

  return { withdrawDpa: mutateAsync, isLoading: rest.isLoading };
};
